import React from 'react';
import './Contact.css'
import { Col, Row, Container, Form } from 'react-bootstrap';
import contactImg from '../../images/contact.svg'

const Contact = () => {
    return (
        <section id="contact">
            <Container>
                <h2 className='secHeader'>Get In Touch</h2>
                <p className='secP'>And Know More About How We Can Make Design To Delivery Simpler For You</p>
                <Row className="align-items-center">
                    <Col md={6}>
                        <Form >
                            <Row className='contactForm'>
                                <Col md={12} lg={6}>
                                    <Form.Control size="lg" className='my-2' type="text" placeholder="Name" />
                                </Col>
                                <Col md={12} lg={6}>
                                    <Form.Control size="lg" className='my-2' type="text" placeholder="Phone Number" />
                                </Col>
                                <Col md={12} lg={6}>
                                    <Form.Control size="lg" className='my-2' type="text" placeholder="Email" />
                                </Col>
                                <Col md={12} lg={6}>
                                    <Form.Control size="lg" className='my-2' type="text" placeholder="Company" />
                                </Col>
                                <Col md={12} lg={6}>
                                    <Form.Control size="lg" className='my-2' type="text" placeholder="Country" />
                                </Col>
                                <Col md={12} lg={6}>
                                    <Form.Select size="lg" className='my-2 form-control'>
                                        <option>Select</option>
                                        <option>Buyer</option>
                                        <option>Factory</option>
                                    </Form.Select>
                                </Col>
                                <Col md={12}>
                                    <Form.Control size="lg" className='my-2 commentBox' type="text" placeholder="Comments"  as="textarea"/>
                                </Col>
                            </Row>
                            <div className="contactBtnBox">
                                <button type='submit' className='submitBtn'>Submit</button>
                            </div>
                        </Form>
                    </Col>
                    <Col md={6}>
                        <div className="contactImg">
                            <img src={contactImg} alt="" className="img-fluid"/>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Contact;